
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Calendar, Globe, Users, UserCog } from "lucide-react";
import { format } from "date-fns";

interface SubscriberInfoProps {
  subscriber: {
    phoneNumber: string;
    status: string;
    createdAt: string;
    timezone: string;
    adminUserId?: string | null;
  };
}

export function SubscriberInfo({ subscriber }: SubscriberInfoProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base flex items-center">
          <Users className="h-4 w-4 mr-2" />
          Subscriber Information
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <p className="text-sm font-medium text-muted-foreground">Phone Number</p>
            <p>{subscriber.phoneNumber}</p>
          </div>
          <div>
            <p className="text-sm font-medium text-muted-foreground">Status</p>
            <Badge variant={subscriber.status === 'active' ? 'default' : 'secondary'}>
              {subscriber.status}
            </Badge>
          </div>
          <div>
            <p className="text-sm font-medium text-muted-foreground">Registered On</p>
            <p className="flex items-center">
              <Calendar className="h-4 w-4 mr-1 inline text-muted-foreground" />
              {format(new Date(subscriber.createdAt), 'MMMM d, yyyy')}
            </p>
          </div>
          <div>
            <p className="text-sm font-medium text-muted-foreground">Timezone</p>
            <p className="flex items-center">
              <Globe className="h-4 w-4 mr-1 inline text-muted-foreground" />
              {subscriber.timezone}
            </p>
          </div>
        </div>
        
        {subscriber.adminUserId && (
          <div className="col-span-2">
            <p className="text-sm font-medium text-muted-foreground">Admin Status</p>
            <div className="flex items-center mt-1">
              <UserCog className="h-4 w-4 mr-2 text-amber-500" />
              <Badge variant="outline" className="bg-amber-50">
                Linked to Admin Account
              </Badge>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
